import { useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { IconBell, IconArrowRight } from '../../assets/icons'
import HomeBannerCache from '../../components/BasicComponent/HomeBannerCache'
import CardIconsLinkSupport from '../../components/FeatureComponent/CardIconsLinkSupport'
import useLoadHomeCache from '../../hooks/common/useLoadHomeCache'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import './index.scss'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BasePopup from '../../components/BasicComponent/BasePopup'
import BaseButton from '../../components/BasicComponent/BaseButton'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import ResultCriminalCard from './components/ResultCriminalCard'
import ListCriminalRecords from './components/ListCriminalRecords'
import RegisteredPackageInfo from '../../components/FeatureComponent/RegisteredPackageInfo'
import { number_to_price } from '../../helper/common'
import { checkDurationUsageDate } from '../../helper/formatDate'
import appUserService from '../../services/appUserService'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import { useTrafficFineVehicleContext } from '../../context/TrafficFineVehicleContext'

export default function AutoTrafficFineNotificationCheckResult() {
  const history = useHistory()
  const { homeBanners, homeCacheLoading } = useLoadHomeCache()
  const location = useLocation()
  const { state } = location
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [errorPopupOpen, setErrorPopupOpen] = useState(false)
  const [isUpdatingAllowRenew, setIsUpdatingAllowRenew] = useState(false)
  const vehicleActivePackage = state?.vehicleActivePackage
  const allowRenew = Number(vehicleActivePackage?.allowRenew) === 1 ? 1 : 0
  const isLoadingScreenOpen = isUpdatingAllowRenew
  const { userData } = useAppUserContext()
  const { getVehicleLists } = useTrafficFineVehicleContext()
  
  const registrationVehicleNavigationState = {
    trafficFineRegistrationVehicle: {
      vehicleIdentity: !vehicleActivePackage?.productId ? state?.vehicleIdentity : undefined,
      vehicleType: Number(state?.vehicleType) || undefined
    }
  }

  const getBenefits = (productOptionalInfo) => {
    try {
      const benefits = JSON.parse(productOptionalInfo)?.benefits
      return Array.isArray(benefits) ? benefits : []
    } catch {
      return []
    }
  }

  const confirmContent =
    allowRenew === 1
      ? 'Bạn có chắc chắn muốn huỷ gia hạn tự động? Gói của bạn vẫn sẽ hoạt động đến hết thời gian đã thanh toán.'
      : 'Bạn có chắc chắn muốn Gia hạn tự động gói thông báo này không?'

  const handleConfirmUpdateAllowRenew = async () => {
    if (!vehicleActivePackage?.appUserVehicleNotifyInfoId || isUpdatingAllowRenew) {
      return
    }

    const nextAllowRenew = allowRenew === 1 ? 0 : 1

    try {
      setIsUpdatingAllowRenew(true)
      setConfirmOpen(false)

      const res = await appUserService.AppUserVehicleNotifyInfoPartnerUpdateById(
        {
          id: Number(vehicleActivePackage.appUserVehicleNotifyInfoId),
          username: userData?.phoneNumberWithUsernamePrefix,
          data: { allowRenew: nextAllowRenew }
        },
        false
      )

      if (!res || res.statusCode !== 200) {
        throw res || new Error('UPDATE_NOTIFY_PACKAGE_FAILED')
      }

      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: {
          ...state,
          vehicleActivePackage: {
            ...vehicleActivePackage,
            allowRenew: nextAllowRenew
          }
        }
      })
      void getVehicleLists()
    } catch (error) {
      console.error(error)
      setErrorPopupOpen(true)
    } finally {
      setIsUpdatingAllowRenew(false)
    }
  }

  return (
    <div>
      <LayoutPartner headerTitle="Kết quả tra cứu" blendHeaderWithBody={true}>
        <div className="AutoTrafficFineNotificationCheckResult">
          <div className="AutoTrafficFineNotificationCheckResult_card">
            <ResultCriminalCard
              isVehicleWarning={state?.isVehicleWarning}
              checkedAt={state?.checkedAt}
              vehicleType={state?.vehicleType}
              vehicleIdentity={state?.vehicleIdentity}
              criminalCount={state?.criminalCount}
            />
          </div>
          {Array.isArray(state?.criminalData) && state.criminalData.length > 0 ? (
            <div className="AutoTrafficFineNotificationCheckResult_list">
              <ListCriminalRecords
                autoOpen
                vehicleIdentity={state?.vehicleIdentity}
                vehicleType={state?.vehicleType}
                criminalData={state?.criminalData}
                notifyEndDateTime={state?.notifyEndDateTime}
              />
            </div>
          ) : null}
          {vehicleActivePackage?.productId ? (
            <div 
              className="AutoTrafficFineNotificationCheckResult_ManagePackageBtn"
              onClick={() => {
                history.push({
                  pathname: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO,
                  state: {
                    vehicleIdentity: state?.vehicleIdentity,
                    vehicleType: state?.vehicleType,
                    vehicleActivePackage: vehicleActivePackage
                  }
                })
              }}
            >
              <div className="AutoTrafficFineNotificationCheckResult_ManagePackageBtn_left">
                <IconBell />
                <span>Quản lý gói kiểm tra tự động</span>
              </div>
              <div className="AutoTrafficFineNotificationCheckResult_ManagePackageBtn_right">
                <IconArrowRight />
              </div>
            </div>
          ) : null}

          {/* {vehicleActivePackage?.productId && (
            <RegisteredPackageInfo
              productName={vehicleActivePackage?.productName}
              priceText={number_to_price(vehicleActivePackage?.productPriceAfterVAT)}
              allowRenew={allowRenew}
              priceUnit={checkDurationUsageDate(vehicleActivePackage?.usageDate, false)}
              notifyEndDateTime={vehicleActivePackage?.notifyEndDateTime}
              paymentIconUrl={vehicleActivePackage?.paymentIconUrl}
              orderPaymentInfo={vehicleActivePackage?.orderPaymentInfo}
              benefits={getBenefits(vehicleActivePackage?.productOptionalInfo)}
              vehicleType={state?.vehicleType}
              productSize={vehicleActivePackage?.productSize ?? state?.productSize}
              onActionClick={() => {
                if (!vehicleActivePackage?.appUserVehicleNotifyInfoId || isUpdatingAllowRenew) {
                  return
                }

                setConfirmOpen(true)
              }}
            />
          )} */}

          <HomeBannerCache promoBanners={homeBanners} loading={homeCacheLoading} navigationState={registrationVehicleNavigationState} />

          <CardIconsLinkSupport />
        </div>
        <FixedBottom elementPaddingBottom="LayoutPartner">
          <BaseButton
            onClick={() => {
              vehicleActivePackage?.productId
                ? history.goBack()
                : history.push({
                    pathname: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES,
                    state: {
                      trafficFineRegistrationVehicle: {
                        vehicleIdentity: state?.vehicleIdentity || undefined,
                        vehicleType: Number(state?.vehicleType) || undefined
                      }
                    }
                  })
            }}>
            {vehicleActivePackage?.productId ? 'Tra cứu xe khác' : 'Đăng ký nhận thông báo tự động'}
          </BaseButton>
        </FixedBottom>
        <BasePopup
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          onConfirm={handleConfirmUpdateAllowRenew}
          title="Thông báo"
          content={confirmContent}
          closeText="Đóng"
          confirmText="Xác nhận"
        />
        <BasePopup
          open={errorPopupOpen}
          onClose={() => setErrorPopupOpen(false)}
          title="Cập nhật không thành công"
          content="Đã xảy ra lỗi khi cập nhật gia hạn tự động. Vui lòng thử lại sau."
        />
        <LoadingScreen open={isLoadingScreenOpen} />
      </LayoutPartner>
    </div>
  )
}
